import { render } from "./BetaAdmin.vue?vue&type=template&id=c8352e74"
import script from "./BetaAdmin.vue?vue&type=script&lang=js"
export * from "./BetaAdmin.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__